// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","389":"71df2e84","455":"3b37999a"}[chunkId] + ".chunk.js";
};